import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const QuestionModel = [
  {
    field: 'microGlp1_initialConsent',
    label:
      'Thanks for your interest in our program. There may be many different benefits to the GLP-based products class of medication beyond weight loss and diabetes management. Are you aware that “micro-dosing” GLP-based products means using lower-than-standard doses? The program consists of using these medications at low doses to obtain the potential added benefits of this medication. Would you still like to continue?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: "Yes, let's continue", key: 'yes' },
        { value: "No, I'm no longer interested", key: 'no' } // Disqualify
      ]
    }
  },
  {
    // TODO if BMI is under 27 for a treatment naive patient → disqualified; if BMI is under 23 for a patient currently on treatment → disqualified
    label: 'What is your:',
    field: 'microGlp1_weightAndHeight2025',
    type: 'info',
    required: false,
    answer: {
      type: 'bmi',
      showLabel: true,
      bmiLabel: 'Your BMI is',
      heightLabel: 'What is your height in feet and inches?',
      weightLabel: 'What is your weight in pounds?'
    }
  },

  {
    field: 'microGlp1_sex',
    label: 'What was your sex assigned at birth?',
    type: 'select',
    extras: { sendToBeluga: false },
    answer: {
      type: 'single_select',
      options: [
        { value: 'Male', key: 'male' },
        { value: 'Female', key: 'female' }
      ]
    }
  },
  {
    field: 'microGlp1_pregnancyStatus',
    label:
      'Are you currently pregnant, breastfeeding or planning to become pregnant?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' }, // Disqualifying
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'microGlp1_consentPregnancy',
    label: 'Consent (pregnancy):',
    type: 'select',
    educationalSlide:
      'I understand that the medication prescribed to me by my healthcare provider may not be safe to take during pregnancy. I acknowledge that taking this medication while pregnant could pose risks to my health and the health of a developing fetus.\n\nI agree to take necessary precautions to avoid becoming pregnant while using this medication, including the use of effective contraception methods as discussed with my healthcare provider.\n\nI understand that I should stop taking this medication before attempting to become pregnant. I agree to consult with my healthcare provider prior to discontinuing the medication and before planning a pregnancy to ensure my safety and well-being.\n\nBy selecting below, I confirm that I have read and understand the information provided above. I consent to proceed with the treatment under these conditions.',
    answer: {
      type: 'single_select',
      options: [
        {
          value: 'I have read the information and do NOT wish to proceed', // Disqualifying
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I have read and understand the above information, I understand the risks and wish to proceed',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    field: 'microGlp1_desiredOutcomes',
    label:
      'Which outcome(s) are you most interested in for micro-dose GLP-based products? (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value:
            'Improve metabolic health (e.g., insulin sensitivity, glycemic control)',
          key: 'metabolic_health'
        },
        {
          value: 'Assistance in maintaining my weight',
          key: 'weight_maintenance'
        },
        { value: 'Longevity / healthy aging', key: 'longevity' },
        {
          value: 'Cognitive function / neuroprotection',
          key: 'cognitive_function'
        },
        { value: 'Energy and mood enhancement', key: 'energy_mood' },
        { value: 'Reduce inflammation', key: 'inflammation' },
        { value: 'Reduce PCOS symptoms', key: 'pcos' }
      ]
    }
  },
  {
    field: 'microGlp1_concernDuration',
    label: 'How long has this been a concern for you?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'It has been less than 6 months', key: 'less_6_months' },
        { value: '6-12 months', key: '6_12_months' },
        { value: '1-5 years', key: '1_5_years' },
        { value: 'It has been over 5 years', key: 'over_5_years' }
      ]
    }
  },
  {
    field: 'microGlp1_priorGlp1Use',
    label:
      'Have you ever used a GLP-based products medication (e.g. semaglutide, liraglutide, tirzepatide)?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'microGlp1_priorGlp1Medications',
    label: 'Which medication did you take? (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'None of the below', key: 'none', uncheckOthers: true },
        { value: 'Semaglutide (Wegovy/Ozempic)', key: 'semaglutide' },
        { value: 'Tirzepatide (Mounjaro/Zepbound)', key: 'tirzepatide' },
        { value: 'Liraglutide (Saxenda)', key: 'liraglutide' },
        { value: 'Exenatide (Byetta)', key: 'exenatide' },
        { value: 'Dulaglutide (Trulicity)', key: 'dulaglutide' }
      ]
    }
  },
  {
    field: 'microGlp1_priorSideEffects',
    label: 'Did you experience any side effects?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'microGlp1_sideEffectsDescription',
    label: 'Tell us more about what you experienced',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'microGlp1_sideEffectsDescription'
    }
  },
  {
    field: 'microGlp1_medicalHistory',
    label:
      'Please check all current or past medical conditions: (Select all that apply)',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'None of the below', key: 'none', uncheckOthers: true },
        {
          value: 'Gastroparesis (Paralysis of your intestines)',
          key: 'gastroparesis'
        },
        {
          value: 'Triglycerides over 600 at any point',
          key: 'high_triglycerides'
        },
        { value: 'Pancreatic cancer', key: 'pancreatic_cancer' },
        { value: 'History of pancreatitis', key: 'pancreatitis' },
        { value: 'Type 1 Diabetes', key: 'type1_diabetes' },
        { value: 'Hypoglycemia (low blood sugar)', key: 'hypoglycemia' },
        {
          value: 'Insulin-dependent diabetes',
          key: 'insulin_dependent_diabetes'
        },
        {
          value: 'Personal or family history of medullary thyroid cancer',
          key: 'thyroid_cancer'
        },
        {
          value:
            'Personal or family history of Multiple Endocrine Neoplasia (MEN-2) syndrome',
          key: 'men2_syndrome'
        },
        { value: 'Anorexia or bulimia', key: 'eating_disorder' },
        {
          value: 'Current symptomatic gallstones',
          key: 'symptomatic_gallstones'
        },
        { value: 'Type 2 Diabetes', key: 'type2_diabetes' },
        { value: 'Chronic Kidney Disease Stage 3 or greater', key: 'ckd' },
        { value: 'Liver failure/cirrhosis', key: 'liver_failure' },
        {
          value:
            'Uncontrolled heart disease such as coronary artery disease or congestive heart failure which has required hospital admission within the last year',
          key: 'uncontrolled_heart_disease'
        },
        {
          value: 'Syndrome of Inappropriate Antidiuretic Hormone (SIADH)',
          key: 'siadh'
        },
        {
          value: 'Gallbladder disease or past removal of your gallbladder',
          key: 'gallbladder'
        }
      ]
    }
  },
  {
    field: 'microGlp1_consentGallbladder',
    label: 'Consent (gallbladder):',
    type: 'select',
    educationalSlide:
      "Read the following for more information about this product and its potential side effects.\n\nGallbladder disease information:\nYou noted that you have gallbladder disease or previous removal of our gallbladder. This medication may still be a good option.  However, this medication can affect how the body handles fats and bile. If you have had your gallbladder removed, the body's ability to store and release bile is altered. Bile is crucial for digestion and fat absorption. This medication may increase the likelihood of gastrointestinal side effects in these individuals because it can alter fat metabolism and bile flow. This can lead to symptoms such as diarrhea and stomach pain.\n\nAdditionally, medications that affect digestion and appetite, like this medication, might alter the absorption and metabolism of other nutrients (like fat soluble vitamins such as vitamin A, D, E, and K) and medications. This is particularly important for those without a gallbladder, as their digestive system already operates differently from those with a functioning gallbladder. If you wish to move forward, it is important to eat smaller and more frequent meals. In addition, to ensure that you're receiving enough vitamins, you should avoid processed foods while eating plenty of fruits and vegetables, as well as considering the use of a multi-vitamin unless told by your provider to avoid these for other reasons.\n\nIf you have asymptomatic gallstones, please note that these medications and weight loss itself may result in gallstone formation which could result in the obstruction of the normal flow of bile which can result in infection, pancreatitis, and/or emergent need for gallbladder removal.  It is important to receive prompt medical evaluation if symptoms appear as delayed action may result in serious harm or death if untreated.",
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read the above information and I do NOT wish to continue', // Disqualifying
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I acknowledge that I have read and understood the above information and wish to continue.',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    field: 'microGlp1_gastricBypass',
    label: 'Have you had a gastric bypass in the past 6 months?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' }, // Disqualifying
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'microGlp1_medicationAllergies',
    label: 'Are you allergic to any of the following?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { value: 'Ozempic (Semaglutide)', key: 'ozempic' }, // Disqualifying
        { value: 'Mounjaro (Tirzepatide)', key: 'mounjaro' }, // Disqualifying
        { value: 'Wegovy (Semaglutide)', key: 'wegovy' }, // Disqualifying
        { value: 'Zepbound (Tirzepatide)', key: 'zepbound' }, // Disqualifying
        { value: 'Saxenda (Liraglutide)', key: 'saxenda' }, // Disqualifying
        { value: 'Trulicity (dulaglutide)', key: 'trulicity' }, // Disqualifying
        { value: 'None of the above', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'microGlp1_contraindicatedMedications',
    label: 'Do you take any of the following medications?',
    educationalSlide: `
- Insulin
- Glimepiride (Amaryl)
- Meglitinides such as repaglinide or nateglinide
- Glipizide (Glucotrol and Glucotrol XL)
- Glyburide (Micronase, Glynase, and Diabeta)
- Sitagliptin
- Saxagliptin
- Linagliptin
- Alogliptin
    `,
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' }, // Disqualifying
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'microGlp1_additionalQuestions',
    label: 'What other information or questions do you have for the doctor?',
    type: 'info',
    answer: {
      type: 'text',
      rows: 4,
      name: 'microGlp1_additionalQuestions'
    }
  },

  {
    field: 'microGlp1_consentTruthfulness',
    label: 'Consent (Truthfulness):',
    type: 'select',
    educationalSlide:
      'Please attest to the following confirming that all information you have provided to us is true and complete.\n\nI verify that I am the patient and that I have answered the questions asked in this intake form.  I confirm that I have reviewed and understood all the questions asked of me.  I attest that the answers and information I have provided in this questionnaire is true and complete to the best of my knowledge. I understand that it is critical to my health to share complete health information with my doctor.  I will not hold the doctor or affiliated medical practice responsible for any oversights or omissions, whether intentional or not, in the information that I provided.',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read the above information and I do NOT wish to continue', // Disqualifying
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I have read the above information and I do consent and wish to move forward',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },
  {
    field: 'microGlp1_consentMedicationSpecific',
    label: 'Consent (Medication Specific):',
    type: 'select',
    educationalSlide:
      'Indication for Use:\nYou are requesting micro-dose therapy with a GLP-based products receptor agonist (e.g., semaglutide, tirzepatide) to support metabolic health, appetite regulation, reduction of inflammation, and cellular well-being. These very low doses are below the standard therapeutic range and are intended to explore potential wellness benefits.  This is considered "off-label" and is not an FDA approved use of this medication.\n\nCompounded Formulations:\nCompounded semaglutide and tirzepatide are custom-prepared by a licensed pharmacist to meet your individual needs. This allows for tailored dosing schedules, alternative routes of administration, or the addition of agents to help minimize side effects. Because compounded medications are not subject to the same extensive clinical trials as FDA-approved products, their consistency, efficacy, and safety profiles may vary.\n\nPotential Benefits:\nSupport for metabolic balance and appetite control\nPotential reduction in systemic inflammation\nEarly/preliminary neuroprotective or anti-aging effects\nEnhancement of cellular "well-being"\n\nPotential Side Effects:\nAlthough micro-dosing may lower risk, these therapies can still cause adverse reactions, including:\nCommon: nausea, vomiting, diarrhea or constipation, decreased appetite, indigestion\nSerious: pancreatitis (severe abdominal pain, nausea, vomiting which can be deadly), gallbladder issues, kidney impairment, allergic reactions (rash, itching, swelling), gastroparesis (slowed gastric emptying)\n\nRisks and Considerations:\nCompounded formulations may vary in potency and purity. Please obtain your medication from the pharmacy we designate to ensure quality. Inform your provider immediately if you experience side effects.\n\nMonitoring and Follow-Up:\nRegular follow-up visits will assess your response, adjust dosing, and monitor for side effects. We may request periodic verification of your progress.\n\nAcknowledgment and Consent:\nI have read and understand the information above regarding micro-dose GLP-based products therapy, including its compounded nature, potential benefits, risks, and monitoring requirements.',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read the above information and I do NOT wish to continue', // Disqualifying
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I have read and understand the above information and I do consent and wish to move forward with this treatment plan',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  },

  {
    field: 'microGlp1_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'microGlp1_didNotConsent',
    label: 'We need your consent to continue',
    subLabel:
      'You did not agree to the terms shown on the previous step. Without that consent, we cannot move forward with your visit or prescribe treatment.',
    extras: { sendToBeluga: false },
    reject: true,
    answer: {},
    type: 'info',
    isLast: true
  },
  {
    class: 'ineligible',
    field: 'microGlp1_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    extras: { sendToBeluga: false },
    reject: true,
    answer: {},
    type: 'info',
    isLast: true
  }
] as const;

const _type = QuestionModel;
export type MicroGlp1FieldAnswers = Partial<QuestionAnswerMap<typeof _type>>;

export default QuestionModel;

